<template>
  <modal
    :show.sync="showReleasePopup"
    modal-classes="modal-dialog-centered modal-lg"
    body-classes="pt-1"
    @close="closeModalReleasePopup(false)"
    no-close-on-backdrop
  >
    <div class="release-height">
      <div class="articles">
        <span class="date-article">
          Version: {{ document.release.version }} — Released
          {{ formatDate(document.date) }}
        </span>
        <h1 class="title-article ">
          What’s New in RhomTrip Mobility 🚀
        </h1>
        <div v-html="document.content"></div>
      </div>
    </div>
    <template slot="footer">
      <base-alert type="info" class="info-min mb-2 w-100">
        <i class="flaticon-warning mr-1"></i>
        This update requires the app to refresh in order to apply the latest
        changes.
      </base-alert>

      <base-button
        type="primary"
        class="min-button ml-auto"
        @click="updateAppVersion()"
      >
        Update Now
      </base-button>
    </template>
  </modal>
</template>

<script>
import moment from "moment";
import Swal from "sweetalert2";
export default {
  name: "ReleasePopup",
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    document: {
      type: Object,
      default: () => ({}),
      description: "Release document details"
    }
  },
  data() {
    return {
      showReleasePopup: true
    };
  },
  async created() {
    this.showReleasePopup = this.show;
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showReleasePopup = current;
      },
      deep: true
    }
  },
  methods: {
    closeModalReleasePopup(status) {
      this.showReleasePopup = status;
      this.$emit("close", status);
    },
    formatDate(date) {
      return moment.parseZone(date).format("DD-MMM-YYYY");
    },
    async updateAppVersion() {
      let { value } = await Swal.fire({
        title: "Confirm Update",
        html: `Updating now will refresh the app to apply the latest improvements.<br> <strong> Please note: </strong> any unsaved changes may be lost.`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/info.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        allowOutsideClick: false,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      });
      if (value) {
        localStorage.setItem("appVersion", this.document.release.version);
        this.closeModalReleasePopup(false);
        window.location.reload();
      }
    }
  }
};
</script>
